var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mt-16"},[_c('PermissionsComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }